let orderHistoryResolver = {

    orderHistoryModel: function(orderService, accountService, notificationService, $window) {
        "ngInject";

        var errObject = [];
        var msg = 'Failed to retrieve order details. Please try again.';
        
        if(accountService.isTradeUser()) {
            $window.location.href = '/myaccount/home';
            return;
        }

        return orderService.retrieveOrderHistoryModel().then(function(result){

            return result;
        }).catch(function(errObject) {

            if (errObject.data != undefined && errObject.data.exception != undefined)
                msg = errObject.data.exception;

            notificationService.notifyWithDefaults({
                title: 'Error',
                title_escape: false,
                text: msg,
                text_escape: false,
                styling: "fontawesome",
                type: "error",
                icon: true,
                buttons: {
                    sticker: false
                },
                delay: 3000
            }, 'custom_stack');

            errObject.error = true;
            errObject.errorText = msg;

            return errObject;
        });
    }
};

export default orderHistoryResolver;



// WEBPACK FOOTER //
// ./src/app/components/order-history/order-history-resolver.js